// The ONE place the product name lives. When the real name is chosen, change
// this file and nothing else. Routes, package names, database names, and
// email templates never embed the name.

export const BRAND = {
  name: 'Fantasy Sports Playground',
  shortName: 'FSP',
  tagline: 'Fantasy sports for friends and family, just for fun.',
} as const;
